import React from "react";
import PropTypes from "prop-types";
import { compose } from "recompose";
import { Field, reduxForm } from "redux-form/immutable";
import { ui } from "components";
import Button from "@material-ui/core/Button";

const FaqForm = ({ handleSubmit, type }) => (
  <form className="auth-form" autoComplete="off">
    <Field
      component={ui.Fields.BaseField}
      name="question"
      props={{
        id: "question",
        label: "question",
        fullWidth: true,
      }}
    />
    <Field component={ui.Fields.EditorField} name="answer" />
    <Button
      variant="outlined"
      onClick={handleSubmit}
      style={{
        marginTop: 20,
        marginBottom: 20,
      }}
    >
      {type === "create" ? "CREATE" : "SAVE"}
    </Button>
  </form>
);

FaqForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
};

export default compose(
  reduxForm({
    form: "faqForm",
  })
)(FaqForm);
